import './_logoPartners.scss'

import PartnersSVG from './Logo'

type Props = {
  api: string
}

const apiToLogo: Record<string, string> = {
  Accepty1: PartnersSVG.Accepty,
  Accepty2: PartnersSVG.Accepty,
  ASDA: PartnersSVG.AsdaMoney,
  'ASDA(H)': PartnersSVG.AsdaMoney,
  'Churchill Loans': PartnersSVG.Churchill,
  'Churchill Loans (Compare the Market)': PartnersSVG.Churchill,
  'Churchill Loans (MSM)': PartnersSVG.Churchill,
  ClearScore: PartnersSVG.ClearScore,
  'RPD-CTM': PartnersSVG.CompareTheMarket,
  'RPD-CNF': PartnersSVG.Confused,
  'RPD-CNFA': PartnersSVG.Confused,
  AFF21: PartnersSVG.Confused,
  'CredAbility (Accepty)': PartnersSVG.CredAbility,
  Bud: PartnersSVG.Bud,
  BudWithIcon: PartnersSVG.BudWithIcon,
  dll: PartnersSVG.DirectLine,
  'ES Money': PartnersSVG.ESMoney,
  Experian: PartnersSVG.Experian,
  EXP: PartnersSVG.Experian,
  'Experian Credit Matcher': PartnersSVG.Experian,
  'Finder.com': PartnersSVG.Finder,
  'Fluent Loans': PartnersSVG.FluentLoans,
  'Forbes Advisor': PartnersSVG.ForbesAdvisor,
  'Freedom Finance': PartnersSVG.FreedomFinance,
  'RPD-GCO': PartnersSVG.GoCompare,
  'RPD-GCOA': PartnersSVG.GoCompare,
  'WLP-HIT': PartnersSVG.Hitched,
  'Monevo (Confused.com)': PartnersSVG.Monevo,
  'Monevo (Credit Karma)': PartnersSVG.Monevo,
  'Monevo (Money.co.uk)': PartnersSVG.Monevo,
  'Monevo (Money Guru)': PartnersSVG.Monevo,
  AFF6: PartnersSVG.Money,
  MGU: PartnersSVG.MoneyGuru,
  MoneySavingExpert: PartnersSVG.MoneySavingExpert,
  MoneySupermarket: PartnersSVG.MSM,
  AFF30: PartnersSVG.MSM,
  AFF29: PartnersSVG.MSM,
  'Norton Finance': PartnersSVG.NortonFinance,
  'Ocean Finance': PartnersSVG.OceanFinance,
  REV: PartnersSVG.Revolut,
  REV2: PartnersSVG.Revolut,
  'RPD-DFT': PartnersSVG.Runpath,
  'RPD-DET': PartnersSVG.Runpath,
  'RPD-RPD': PartnersSVG.Runpath,
  'Simply Money': PartnersSVG.SimplyMoney,
  SmarterSavings: PartnersSVG.SmarterSavings,
  AFF3: PartnersSVG.TotallyMoney,
  TMO: PartnersSVG.TotallyMoney,
  Fluro: PartnersSVG.Fluro,
  INT14: PartnersSVG.LoansWarehouse,
  INT21: PartnersSVG.ClearScore,
  INT12: PartnersSVG.ClearScore,
}

const LogoPartners = ({ api }: Props): JSX.Element => {
  const partnerLogoSrc = apiToLogo[api] ?? PartnersSVG.Fluro

  if (partnerLogoSrc === PartnersSVG.Fluro) {
    return <img src={partnerLogoSrc} alt="Fluro" className="logo-partners__single" />
  }

  return (
    <div className="logo-partners">
      <span className="logo-partners__heading">Partnered with</span>
      <img src={partnerLogoSrc} alt="Partner" className="logo-partners__partner" />
    </div>
  )
}

export default LogoPartners
